// extracted by mini-css-extract-plugin
module.exports = {"list__check":"ibanEntityList_list__check__1Ed37","list__downloadButton":"ibanEntityList_list__downloadButton__2sV91"};